import { useMemo } from 'react'

import { ColumnConfig, ColumnPinning } from '../../DataGrid.types'
import { getColumnPinning, getColumnsGroupingSetup } from '../../utils'

interface ColumnGroup {
  groupId: string
  colStart: number
  colEnd: number
  columnPinning: ColumnPinning
}

export function useColumnGrouping<RowType>(
  columns: ColumnConfig<RowType>[],
  pinnedColumns: number,
  pinnedColumnsRight: number,
) {
  return useMemo(() => {
    const { hasColumnGrouping } = getColumnsGroupingSetup(columns)
    const columnGroups = hasColumnGrouping
      ? columns.reduce<ColumnGroup[]>((groups, column, columnIndex) => {
          if (!column.groupId) {
            return groups
          }
          const lastGroup = groups.length > 0 ? groups[groups.length - 1] : undefined
          if (lastGroup && lastGroup.groupId === column.groupId) {
            lastGroup.colEnd += 1
          } else {
            const newGroup: ColumnGroup = {
              groupId: column.groupId,
              colStart: columnIndex + 1,
              colEnd: columnIndex + 2,
              columnPinning: getColumnPinning(
                columnIndex,
                pinnedColumns,
                pinnedColumnsRight,
                columns,
              ),
            }
            groups.push(newGroup)
          }

          return groups
        }, [])
      : undefined

    return { hasColumnGrouping, columnGroups }
  }, [columns, pinnedColumns, pinnedColumnsRight])
}
